import PropTypes from 'prop-types';
import {Tooltip} from '@material-ui/core';
import {Translate} from 'react-redux-i18n';

const DOWNLOAD_AVAILABLE_STATES = ['VALID', 'SIGNED', 'ALMOST_EXPIRED', 'NOT_APPLICABLE', 'EXPIRED'];

function DownloadButtonsView({document, onDocumentFileOpen, onDocumentProofFileOpen}) {
  const downloadAvailable = DOWNLOAD_AVAILABLE_STATES.includes(document.state) && document.hasFile;

  function handleOpen(downloadFn) {
    if (downloadAvailable) {
      downloadFn(document);
    }
  }

  function getButton(label, downloadFn) {
    return (
      <Tooltip
        title={downloadAvailable ? '' : <Translate value="document.canNotDownload"/>}
        placement="left"
      >
        <span>
          <button
            type="button"
            className="small secondary no-wrap"
            onClick={() => handleOpen(downloadFn)}
            disabled={!downloadAvailable}
            style={!downloadAvailable ? {pointerEvents: 'none'} : {}}
          >
            <Translate value={label}/>
          </button>
        </span>
      </Tooltip>
    );
  }

  return (
    <>
      {document.hasProofFile && getButton('document.openProof', onDocumentProofFileOpen)}
      {getButton('document.open', onDocumentFileOpen)}
    </>
  );
}

DownloadButtonsView.propTypes = {
  document: PropTypes.object.isRequired,
  onDocumentFileOpen: PropTypes.func.isRequired,
  onDocumentProofFileOpen: PropTypes.func
};

export default DownloadButtonsView;
